import React from "react";
import { Provider } from "react-redux";
import { Outlet } from "react-router-dom";
import { checkShipmentStore } from "./store";

export const CheckShipmentByCargo: React.FC = () => {
  return (
    <Provider store={checkShipmentStore}>
      <Outlet />
    </Provider>
  );
};
